<template>
    <section v-if="!error" class="ssq-answers">
        <h3 class="ssq-answers-title">Your details</h3>
        <p class="ssq-answers-intro">
            This quotation is based on the information you provided. If you need to make any changes, please call us.
        </p>

        <div v-if="loading" class="ssq-answers-loading"><span class="ssq-spin"></span> Loading your details…</div>

        <!-- Same card markup as the MyPolicy quote-details view, for matching striped tables. -->
        <div v-else class="row">
            <div v-for="(card, i) in cards" :key="i" :class="[card.span === 2 ? 'col-12' : 'col-sm-12 col-md-6', 'mB-15']">
                <div class="card h-100">
                    <div class="card-header"><h5 class="card-title mB-0">{{ card.title }}</h5></div>
                    <div class="card-body"><QuoteSummary :items="card.children" :label-width="card.labelWidth" /></div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue';
import QuoteSummary from './QuoteSummary.vue';
import { useSchemaAnswerSteps } from './useSchemaAnswerSteps';
import type { SummarySection } from './schemaSummary';

defineOptions({ name: 'ReviewedAnswers' });

// riskData comes from the journey store, already seeded and canonicalised for this quote.
const props = defineProps<{ productId: string; riskData: any }>();

const { loading, error, steps, load } = useSchemaAnswerSteps();

// Flatten all steps' cards into one scroll (fallback cards already carry the step name as their title).
const cards = computed<SummarySection[]>(() => steps.value.flatMap((s) => s.cards));

watch(() => props.productId, (id) => { if (id) load(id, props.riskData); }, { immediate: true });
</script>
